import React from "react";
import { Button, Checkbox, Form, Input, notification } from "antd";

import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import apiPostAuth from "../../api/login/postAuth";
import { setuserloginStored, setauthUserStored } from "../../stored/mydata";

export default function Login(props) {
  const dispatch = useDispatch();
  var navigate = useNavigate();

  const [api, contextHolder] = notification.useNotification();

  const onFinish = (values) => {
    // console.log("Success:", values);

    var data = {
      username: values["username"],
      password: values["password"],
    };

    apiPostAuth(data, (err, res) => {
      if (!err && res["accessToken"]) {
        dispatch(setuserloginStored(true));
        dispatch(setauthUserStored(res["accessToken"]));

        navigate("/deviceroom");
      } else {
        api["error"]({
          message: res["message"],
          description: "Successfully",
        });
      }
    });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      {contextHolder}
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Please input your username!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password />
        </Form.Item>

        {/* <Form.Item name="remember" valuePropName="checked" label={null}>
          <Checkbox>Remember me</Checkbox>
        </Form.Item> */}

        <Form.Item label={null}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
